import styled from 'styled-components'

import { Cover, Reset, TransitionPrimary } from '@/lib/mixins'

export const CartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const CartTable = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
  background-color: var(--color-light);
  border: 2px solid var(--color-light);
  border-radius: 1rem;
  padding: 0.5rem;
`

export const CartFooter = styled.div`
  width: 75%;
  margin: 1rem auto 0;
  flex-shrink: 0;
`

export const CartSummaryWrapper = styled.div`
  flex-shrink: 0;
  margin-top: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;

  h3 {
    font-size: 1.2rem;
    margin-bottom: 0.25rem;
    color: ${({ theme }) => theme.colors.global};
  }
  h2 {
    font-size: 3rem;
    color: ${({ theme }) => theme.colors.primary};
    margin-bottom: 0;
  }
`

export const CartItemWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem 1rem;
  background-color: var(--color-body);
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
`

export const CartItemImage = styled.div`
  flex: 0 0 4rem;
  flex-shrink: 0;
  height: 4rem;

  img {
    height: 100%;
    object-fit: contain;
    display: block;
    width: 100%;
  }
`
export const CartItemRemove = styled.button`
  ${Reset('button')}
  width: 2.5rem;
  height: 2.5rem;
  flex-shrink: 0;
  border-radius: 50%;
  border: 2px solid var(--color-global);
  margin-left: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  ${TransitionPrimary('background-color', 'color')}

  &:hover {
    background-color: var(--color-global);
    color: var(--color-light);
  }

  svg {
    width: 1.5rem;
    fill: currentColor;
    display: block;
  }
`

export const CartItemContent = styled.div`
  position: relative;
  flex: 1 1 auto;
  padding-left: 2rem;
  padding-right: 2rem;

  h4 {
    font-size: 1.1rem;
    margin-bottom: 0;
  }
  > span {
    color: var(--color-muted);
    font-size: 0.8rem;
    letter-spacing: 0.15em;
  }
`

export const CartItemTools = styled.div`
  display: flex;
  align-items: center;
`

export const CartEmpty = styled.div`
  max-width: 14rem;
  margin: 20vh auto;
  text-align: center;
  opacity: 0.5;
`

export const CartItemPrice = styled.h3`
  margin-bottom: 0;
  margin-right: auto;
  display: inline-flex;
  align-items: center;

  > span {
    margin-right: 0.5em;
    font-size: 0.8em;
    font-weight: 400;
  }
`

export const CartModalImages = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 3rem;
    margin: 0 0.15rem;
  }
`

export const ButtonList = styled.div`
  margin-top: 1rem;
  text-align: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  width: 20%;

  margin: 0 auto;

  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  border: 1px solid var(--color-line);
  border-radius: 1rem;
  cursor: pointer;
`
